<template>
  <div class="Declaration">
    <ModuleName :ModouleName="ModouleName"></ModuleName>
    <div class="Declaration_text">
      本数据由<span class="emphasis">{{Declaration.creator}}({{Declaration.releaseMech}})</span>创建，仅可免费用于学术用途和其他非商业用途。未经事先许可，不得重新发行或用于商业用途。使用本产品的用户应明确标明来源及作者。
    </div>
  </div>
</template>

<script>
export default {
  props: ["Declaration"],
  data() {
    return {
      ModouleName: "数据使用声明",
    };
  },
  components: {
    ModuleName: () => import("@/components/DataDetails/Details/ModuleName.vue"),
  },
};
</script>

<style lang="scss" scoped>
.Declaration_text{
    font-size: 14px;
    .emphasis{
    color: #128bed;
}
}

</style>